import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import isBoolean from 'lodash/isBoolean';
import * as analytics from '../../services/analytics';
import './Passport360EnrollmentBeneficiariesOptionView.css';

const propTypes = {
  client: PropTypes.object,
  onNotifyError: PropTypes.func,
  onSubmit: PropTypes.func,
  quote: PropTypes.object,
  updateQuote: PropTypes.func,
};

class Passport360EnrollmentBeneficiariesOptionView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasBeneficiaries: null,
    };
  }

  handleUpdate = (e) => {
    analytics.page('Passport 360 - Enrollment Beneficiaries Option');
    this.setState({
      hasBeneficiaries: e.target.value === 'true',
    });
  };

  handleNext = () => {
    const { onNotifyError, onSubmit, quote, updateQuote } = this.props;

    if (!this.state.hasBeneficiaries) {
      updateQuote({
        ...quote,
        application: {
          ...quote.application,
          beneficiaries: [],
        },
      })
        .then(() => {
          onSubmit(this.state.hasBeneficiaries);
        })
        .catch(onNotifyError);
    } else {
      onSubmit(this.state.hasBeneficiaries);
    }
  };

  get title() {
    if (this.props.actor === 'broker') {
      return `Would ${this.props.client.person.first_name} like to name a beneficiary?`;
    } else {
      return 'Would you like to name a beneficiary?';
    }
  }

  render() {
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-7 p-t-30">
            <h3 className="text-center semi-bold">{this.title}</h3>
            <div className="Passport360EnrollmentBeneficiariesOptionView-clientDetails card m-t-20">
              <div className="card-block">
                <div className="radio radio-success">
                  <input
                    id="radioTrue"
                    type="radio"
                    name="hasBeneficiaries"
                    value="true"
                    checked={this.state.hasBeneficiaries === true}
                    onChange={this.handleUpdate}
                  />
                  <label
                    className="Passport360EnrollmentBeneficiariesOptionView-radio"
                    htmlFor="radioTrue"
                  >
                    <strong className="Passport360EnrollmentBeneficiariesOptionView-radio-label">
                      Yes
                    </strong>
                  </label>

                  <input
                    id="radioFalse"
                    type="radio"
                    name="hasBeneficiaries"
                    value="false"
                    checked={this.state.hasBeneficiaries === false}
                    onChange={this.handleUpdate}
                  />
                  <label
                    className="Passport360EnrollmentBeneficiariesOptionView-radio"
                    htmlFor="radioFalse"
                  >
                    <strong className="Passport360EnrollmentBeneficiariesOptionView-radio-label">
                      No
                    </strong>
                    <p className="Passport360EnrollmentBeneficiariesOptionView-radio-info">
                      The Loss of Life Benefit Amount will be paid to the estate
                      of the Covered Person unless the Covered Person has
                      designated in writing another beneficiary and the
                      Beneficiary Designation Request is on file with the
                      Company approved Administrator.
                    </p>
                  </label>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <button
                className="btn btn-lg btn-complete"
                disabled={!isBoolean(this.state.hasBeneficiaries)}
                onClick={this.handleNext}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Passport360EnrollmentBeneficiariesOptionView.propTypes = propTypes;

export default Passport360EnrollmentBeneficiariesOptionView;
